import * as React from 'react';

export interface ProfileSectionProps {
  title: string
  anchor: string
}

class ProfileSection extends React.Component<ProfileSectionProps> {
  public render() {
    return (
      <div className="profile-section">
        <div className="columns">
          <div className="column">
            <h1 id={this.props.anchor} className="title has-text-weight-normal">{this.props.title}</h1>

            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default ProfileSection;


// WEBPACK FOOTER //
// ./src/pages/profile/ProfileSection.tsx